import { useMutation, useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '@/lib/react-query';

import { TipsResponse } from '../types';

export type UseServiceTipOptions = {
  id?: string;
  page?: number;
  perPage?: number;
  search?: string;
  order?: string;
  sort?: string;
};
export const getServiceTipDetails = ({
  page,
  perPage,
  id,
  search,
  order,
  sort,
}: UseServiceTipOptions = {}): Promise<TipsResponse> => {
  return axios.get(`/payment/tips/list?`, {
    params: { page, perPage, id, search, order, sort },
  });
};

type QueryFnType = typeof getServiceTipDetails;

export const useServices = ({ id, page, perPage }: UseServiceTipOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['tips'],
    queryFn: () => getServiceTipDetails({ id, page, perPage }),
  });
};

export const useGetServiceTipDetails = ({ id, page, perPage }: UseServiceTipOptions = {}) => {
  const obj = {
    id,
    page: page,
    perPage: perPage,
  };
  return useMutation({
    ...obj,
    mutationFn: getServiceTipDetails,
  });
};
